import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgSearch from '../../svg/search.svg'
import { IconProps } from '../icon-props'

const SearchIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgSearch
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-search', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default SearchIcon
